/**
 * Direct production dependencies from WasOK Flutter app (`wasok/pubspec.yaml`),
 * with resolved versions from `wasok/pubspec.lock` where available.
 *
 * When you change Flutter deps, refresh versions here from `wasok/pubspec.lock`.
 *
 * SPDX/license summaries follow typical pub.dev declarations; verify on pub.dev if needed.
 */
export type FlutterPackageLicense = {
  name: string;
  /** Resolved semver from pubspec.lock */
  version: string;
  description: string;
  /** Primary SPDX identifier(s); icons/fonts may add a short note */
  license: string;
};

export const flutterDirectPackages: FlutterPackageLicense[] = [
  {
    name: "advertising_id",
    version: "2.7.1",
    description:
      "Reads the advertising identifier on Android for ads/analytics integrations.",
    license: "MIT",
  },
  {
    name: "app_tracking_transparency",
    version: "2.0.6+1",
    description:
      "Requests App Tracking Transparency permission on iOS (Apple ATT framework).",
    license: "MIT",
  },
  {
    name: "archive",
    version: "4.0.9",
    description:
      "Encode and decode ZIP and other archive formats in Dart.",
    license: "Apache-2.0",
  },
  {
    name: "file_picker",
    version: "10.3.10",
    description:
      "Native file picker for choosing files from the device filesystem.",
    license: "MIT",
  },
  {
    name: "flutter_animate",
    version: "4.5.2",
    description:
      "Animation effects and utilities for Flutter widgets.",
    license: "MIT",
  },
  {
    name: "flutter_local_notifications",
    version: "21.0.0",
    description:
      "Local notifications on Android, iOS, macOS, and other supported platforms.",
    license: "BSD-3-Clause",
  },
  {
    name: "flutter_localizations",
    version: "SDK",
    description:
      "Flutter SDK localization delegates (Material/Cupertino widgets, locales).",
    license: "BSD-3-Clause",
  },
  {
    name: "flutter_rating_bar",
    version: "4.0.1",
    description:
      "Customizable rating bar / star widgets.",
    license: "MIT",
  },
  {
    name: "flutter_svg",
    version: "2.2.1",
    description:
      "Draw SVG assets as Flutter widgets.",
    license: "MIT",
  },
  {
    name: "font_awesome_flutter",
    version: "11.0.0",
    description:
      "Font Awesome icon pack rendered as Flutter widgets (glyphs under SIL OFL 1.1; wrapping code MIT).",
    license: "MIT + SIL OFL 1.1 (icons)",
  },
  {
    name: "google_mobile_ads",
    version: "8.0.0",
    description:
      "Google Mobile Ads SDK (AdMob) integration for Flutter.",
    license: "Apache-2.0",
  },
  {
    name: "image",
    version: "4.8.0",
    description:
      "Dart image encoding/decoding and bitmap manipulation utilities.",
    license: "MIT",
  },
  {
    name: "image_cropper",
    version: "12.2.1",
    description:
      "Crop photos using native cropping UI on Android and iOS.",
    license: "MIT",
  },
  {
    name: "image_picker",
    version: "1.2.0",
    description:
      "Pick images or video from gallery or capture with the camera.",
    license: "Apache-2.0",
  },
  {
    name: "intl",
    version: "0.20.2",
    description:
      "Internationalization and localization helpers (messages, formatting).",
    license: "BSD-3-Clause",
  },
  {
    name: "mime",
    version: "2.0.0",
    description:
      "MIME type detection and MIME multipart helpers.",
    license: "BSD-3-Clause",
  },
  {
    name: "mobile_scanner",
    version: "7.0.1",
    description:
      "Barcode and QR scanning using the device camera.",
    license: "BSD-3-Clause",
  },
  {
    name: "package_info_plus",
    version: "9.0.1",
    description:
      "Reads app package metadata such as version and build number.",
    license: "BSD-3-Clause",
  },
  {
    name: "path",
    version: "1.9.1",
    description:
      "Cross-platform path manipulation (join, split, normalize).",
    license: "BSD-3-Clause",
  },
  {
    name: "path_provider",
    version: "2.1.5",
    description:
      "Locates common filesystem locations (documents, temp, etc.).",
    license: "BSD-3-Clause",
  },
  {
    name: "share_plus",
    version: "11.1.0",
    description:
      "Share text and files via the platform share sheet.",
    license: "BSD-3-Clause",
  },
  {
    name: "shared_preferences",
    version: "2.5.5",
    description:
      "Lightweight persistent key–value storage backed by platform APIs.",
    license: "BSD-3-Clause",
  },
  {
    name: "sqflite",
    version: "2.4.2",
    description:
      "SQLite plugin for Flutter (local relational database).",
    license: "BSD-2-Clause",
  },
  {
    name: "stacked",
    version: "3.5.0",
    description:
      "Flutter MVVM-style architecture primitives (Views and ViewModels).",
    license: "MIT",
  },
  {
    name: "stacked_services",
    version: "1.6.0",
    description:
      "Navigation, dialogs, and snackbars helpers built for Stacked.",
    license: "MIT",
  },
  {
    name: "url_launcher",
    version: "6.3.2",
    description:
      "Launch URLs, email links, and other external schemes from the app.",
    license: "BSD-3-Clause",
  },
];
